import store from '@/store/index'
import constants from '@/store/constants'

const ACCOUNT_TYPES = constants.ACCOUNT_TYPES

class UserModule {
  user = {
    get() {
      return store.state.user
    },
    set(user) {
      store.commit('USER_DETAILS', user)
    }
  }

  userName() {
    return store.state.user.name
  }

  account() {
    return store.state.user.account
  }

  accountIsFree() {
    return store.state.user.account === ACCOUNT_TYPES.FREE
  }

  accountIsPro() {
    return store.state.user.account === ACCOUNT_TYPES.PRO
  }

  accountIsLife() {
    return store.state.user.account === ACCOUNT_TYPES.LIFE
  }
}

export default new UserModule()
